import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import Grid from '@material-ui/core/Grid';
import Divider from '@material-ui/core/Divider';
import productPlaceholder from '../../static/img/product_placeholder.jpg';


const styles = theme => ({
  listItem: {
    padding: `${theme.spacing()}px 0`,
  },
  total: {
    fontWeight: '700',
  },
  title: {
    marginTop: theme.spacing(2),
  },
  productImage: {
    height: 80,
    width: 80,
  },
  price: {
    padding: theme.spacing(),
  },
  headerPrice: {
    padding: theme.spacing(3),
    paddingBottom: theme.spacing(),
  },
  headerQuantity: {
    padding: theme.spacing(3),
    paddingBottom: theme.spacing(),
  },
  headerTotal: {
    padding: theme.spacing(3),
    paddingBottom: theme.spacing(),
    paddingRight: theme.spacing(),
  },
  detailsGrid: {
    paddingLeft: theme.spacing(8),
    paddingRight: theme.spacing(8),
  },
  subtotalContainer: {
    textAlign: 'right',
    margin: theme.spacing(3),
  },
  dividers: {
    margin: theme.spacing(),
  },
  TCsBox: {
    textAlign: 'right',
  },
  link: {
    color: theme.palette.secondary.dark,
    textDecoration: 'none',
  },
});

function Review(props) {
  const {
    classes,
    addressFName,
    addressLName,
    addressLine1,
    addressLine2,
    addressCity,
    addressState,
    addressZip,
    addressCountry,
    paymentMethod,
    lines,
    cart,
    products,
    useStoreCredit,
    oscarAccount,
    methodRequired,
    acceptTCs,
    handleTCsChange,
    shippingCharge,
  } = props;

  let total = parseFloat(cart.total_incl_tax) + parseFloat(shippingCharge.incl_tax);
  total = total.toFixed(2);
  let balance = parseFloat(oscarAccount.balance);
  let creditUsed = 0.00;
  if (useStoreCredit) {
    console.log('using store credit');
    if (balance > total) {
      console.log('balance covers total');
      creditUsed = total;
      balance -= total;
      total = 0.00;
    } else {
      console.log('total is greated than balance');
      creditUsed = balance;
      total -= balance;
      balance = 0.00;
      total = total.toFixed(2);
    }
  }

  // console.log(cart);

  function displayStoreCredit() {
    if (useStoreCredit) {
      return (
        <React.Fragment>
          <Typography>{'Store Credit Used: - $' + creditUsed}</Typography>
          <Typography color="textSecondary">{'Store Credit After Transaction: $' + balance}</Typography>
          <Divider className={classes.dividers} />
        </React.Fragment>
      );
    }
    return null;
  }

  function displayOfferDiscounts() {
    if (!cart) {
      return null;
    }
    return (
      <React.Fragment>
        {cart.offer_discounts.map(item => (
          <Typography key={item.name}>{item.name + ': -' + item.amount}</Typography>
        ))}
      </React.Fragment>
    );
  }

  function displayVoucherDiscounts() {
    if (!cart) {
      return null;
    }
    return (
      <React.Fragment>
        {cart.voucher_discounts.map(item => (
          <Typography key={item.name}>{item.name + ': -' + item.amount}</Typography>
        ))}
      </React.Fragment>
    );
  }

  function displayTax() {
    if (!cart) {
      return null;
    }
    return (
      <React.Fragment>
        <Typography>{'Tax: $' + cart.total_tax}</Typography>
        <Divider className={classes.dividers} />
      </React.Fragment>
    );
  }

  function displayShipping() {
    if (!shippingCharge) {
      return null;
    }
    return (
      <React.Fragment>
        <Typography>{'Shipping: $' + shippingCharge.incl_tax}</Typography>
        <Divider className={classes.dividers} />
      </React.Fragment>
    );
  }

  function renderLines() {
    const reviewLines = [];
    products.forEach((product, i) => reviewLines.push(
      <ListItem key={product.id}>
        { product.images
          ? <img alt="product" className={classes.productImage} src={product.images[0].original} />
          : <img alt="product placeholder" className={classes.productImage} src={productPlaceholder} />
        }
        <ListItemText primary={product.title} />
        <Typography className={classes.headerQuantity}>{lines[i].quantity}</Typography>
        <Typography className={classes.headerPrice} variant="body2" color="textSecondary">{'$' + product.price.excl_tax}</Typography>
        <Typography className={classes.headerTotal} vairnat="body2">{'$' + lines[i].price_excl_tax}</Typography>
      </ListItem>
    ));
    return reviewLines;
  }

  return (
    <React.Fragment>
      <ListItem className={classes.noPaddingBottom}>
        <ListItemText>
          <Typography variant="h6">Cart Summary</Typography>
        </ListItemText>
        <Typography className={classes.headerQuantity} variant="subtitle2">Quantity</Typography>
        <Typography className={classes.headerPrice} variant="subtitle2">Price</Typography>
        <Typography className={classes.headerTotal} variant="subtitle2">Total</Typography>
      </ListItem>
      <List disablePadding>
        { !lines || lines.length < 1 || !cart
          ? <Typography variant="body1">Your cart is currently empty</Typography>
          : renderLines()
        }
      </List>
      <Grid container spacing={2} className={classes.detailsGrid}>
        <Grid className={classes.subtotalContainer} item xs={12}>
          <Typography className={classes.inline}>Cart Total: </Typography>
          { !lines || lines.length < 1 || !cart
            ? <Typography className={classes.inline} color="secondary">$0.00</Typography>
            : <Typography className={classes.inline} color="secondary">{'$' + cart.total_excl_tax_excl_discounts}</Typography>
          }
          <Divider className={classes.dividers} />
          {displayOfferDiscounts()}
          {displayVoucherDiscounts()}
          {displayShipping()}
          {displayTax()}
          {displayStoreCredit()}
          <Typography className={classes.inline} variant="h6">Order Total: </Typography>
          { !lines || lines.length < 1 || !cart
            ? <Typography className={classes.inline} variant="h6" color="secondary">$0.00</Typography>
            : <Typography className={classes.inline} variant="h6" color="secondary">{'$' + total}</Typography>
          }
        </Grid>
        <Grid item xs={12} sm={6}>
          <Typography variant="h6" gutterBottom className={classes.title}>
            Shipping
          </Typography>
          <Typography gutterBottom>{addressFName + ' ' + addressLName}</Typography>
          <Typography gutterBottom>{addressLine1}</Typography>
          <Typography gutterBottom>{addressLine2}</Typography>
          <Typography gutterBottom>{addressCity + ', ' + addressState + ', ' + addressZip}</Typography>
          <Typography gutterBottom>{addressCountry}</Typography>
        </Grid>
        {methodRequired && (
          <Grid item container direction="column" xs={12} sm={6}>
            <Typography variant="h6" gutterBottom className={classes.title}>
              Payment details
            </Typography>
            {paymentMethod.type === 'cc' // this is a saved credit card
              && (
              <Grid container>
                <Grid item xs={6}>
                  <Typography gutterBottom>Card Type:</Typography>
                </Grid>
                <Grid item xs={6}>
                  <Typography gutterBottom>{paymentMethod.card_type}</Typography>
                </Grid>
                <Grid item xs={6}>
                  <Typography gutterBottom>Card Number:</Typography>
                </Grid>
                <Grid item xs={6}>
                  <Typography gutterBottom>{paymentMethod.last4}</Typography>
                </Grid>
                <Grid item xs={6}>
                  <Typography gutterBottom>Expires:</Typography>
                </Grid>
                <Grid item xs={6}>
                  <Typography gutterBottom>{paymentMethod.expiration_month + '/' + paymentMethod.expiration_year}</Typography>
                </Grid>
              </Grid>
              )
            }
            {paymentMethod.type === 'paypal' // this is a saved paypal account
              && (
              <Grid container>
                <Grid item xs={12}>
                  <Typography gutterBottom>PayPal Account:</Typography>
                </Grid>
                <Grid item xs={12}>
                  <Typography gutterBottom>{paymentMethod.email}</Typography>
                </Grid>
              </Grid>
              )
            }
            {paymentMethod.type === 'CreditCard' // this is a one time credit card nonce from braintree
              && (
              <Grid container>
                <Grid item xs={6}>
                  <Typography gutterBottom>Card Type:</Typography>
                </Grid>
                <Grid item xs={6}>
                  <Typography gutterBottom>{paymentMethod.details.cardType}</Typography>
                </Grid>
                <Grid item xs={6}>
                  <Typography gutterBottom>Card Number:</Typography>
                </Grid>
                <Grid item xs={6}>
                  <Typography gutterBottom>{paymentMethod.details.lastFour}</Typography>
                </Grid>
              </Grid>
              )
            }
            {paymentMethod.type === 'PayPalAccount' // this is a one time paypal nonce from braintree
              && (
              <Grid container>
                <Grid item xs={12}>
                  <Typography gutterBottom>PayPal Account:</Typography>
                </Grid>
                <Grid item xs={12}>
                  <Typography gutterBottom>{paymentMethod.details.email}</Typography>
                </Grid>
              </Grid>
              )
            }
          </Grid>
        )}
        <Grid className={classes.TCsBox} item xs={12}>
          <FormControlLabel
            control={(
              <Checkbox
                checked={acceptTCs}
                onChange={e => handleTCsChange(e)}
                color="secondary"
              />
            )}
            label={(
              <span>I have read and agree to the <a target="_blank" className={classes.link} href="/terms">Terms + Conditions</a></span>
            )}
          />
        </Grid>
      </Grid>
    </React.Fragment>
  );
}

Review.propTypes = {
  classes: PropTypes.object.isRequired,
  addressFName: PropTypes.string.isRequired,
  addressLName: PropTypes.string.isRequired,
  addressLine1: PropTypes.string.isRequired,
  addressLine2: PropTypes.string.isRequired,
  addressCity: PropTypes.string.isRequired,
  addressState: PropTypes.string.isRequired,
  addressZip: PropTypes.string.isRequired,
  addressCountry: PropTypes.string.isRequired,
  paymentMethod: PropTypes.object.isRequired,
  lines: PropTypes.array.isRequired,
  cart: PropTypes.object.isRequired,
  products: PropTypes.array.isRequired,
  useStoreCredit: PropTypes.bool.isRequired,
  oscarAccount: PropTypes.object.isRequired,
  methodRequired: PropTypes.bool.isRequired,
  acceptTCs: PropTypes.bool.isRequired,
  handleTCsChange: PropTypes.func.isRequired,
  shippingCharge: PropTypes.object.isRequired,
};

export default withStyles(styles)(Review);
